'use strict';

var _ = require('lodash');
function ConfigurationHostShareService(restangular, $http, fileSaveService) {
  var hostShareRest = restangular.one('configuration').one('hep').all('hostshare');
  function deleteUnneededAttributes(newEntity) {
    delete newEntity._old;
    delete newEntity._original;
    delete newEntity.originalRowId;
    delete newEntity._links;
  }
  function save(rowsToSave) {
    var payloadEntity = _.transform(rowsToSave, function (result, row) {
      var clonedRow = _.clone(row);
      deleteUnneededAttributes(clonedRow);
      if (clonedRow.month === '') {
        delete clonedRow.month;
      }
      clonedRow.hepKey = clonedRow.hepKey || '';
      result.push(clonedRow);
    });
    return hostShareRest.customPUT(payloadEntity);
  }
  function remove(rowsToRemove) {
    _.forEach(rowsToRemove, function (row) {
      delete row.uid;
      deleteUnneededAttributes(row);
    });
    return $http({
      method: 'DELETE',
      url: hostShareRest.getRestangularUrl(),
      data: rowsToRemove,
      headers: {
        'Content-Type': 'application/json;charset=UTF-8'
      }
    });
  }
  function formatAsCsvRow(stringArrayToFormat) {
    var rowValues = _.chain(stringArrayToFormat).join(',').value();
    return rowValues + '\r\n';
  }
  function createCsvHeader(fieldsToExport) {
    return formatAsCsvRow(fieldsToExport);
  }
  function createCsvRow(row, fieldsToExport) {
    var valuesToExport = [];
    var formattedFields = ['hostShare', 'hostShareNew', 'diff'];
    _.each(fieldsToExport, function (fieldName) {
      if (_.includes(formattedFields, fieldName)) {
        valuesToExport.push(parseFloat(row[fieldName]).toFixed(4));
      } else {
        valuesToExport.push(row[fieldName]);
      }
    });
    return formatAsCsvRow(valuesToExport);
  }
  function exportToCsv(data, fieldsToExport) {
    var fileData = createCsvHeader(fieldsToExport);
    fileData = _.reduce(data, function (result, row) {
      result += createCsvRow(row, fieldsToExport);
      return result;
    }, fileData);
    fileSaveService.createFile(fileData, 'text/csv', 'HostShare.csv');
  }
  return {
    save: save,
    remove: remove,
    exportToCsv: exportToCsv
  };
}
ConfigurationHostShareService.$inject = ['Restangular', '$http', 'FileSaveService'];
module.exports = ConfigurationHostShareService;